"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _lodash = _interopRequireDefault(require("lodash.set"));

var _lodash2 = _interopRequireDefault(require("lodash.get"));

var _lodash3 = _interopRequireDefault(require("lodash.clonedeep"));

var _fastDeepEqual = _interopRequireDefault(require("fast-deep-equal"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _Validation = _interopRequireDefault(require("../Validation"));

var _trackForm = _interopRequireDefault(require("../../utils/trackForm"));

var _runFormValidation3 = _interopRequireDefault(require("./utils/runFormValidation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setData = function setData(original, key, value) {
  var obj = (0, _lodash3.default)(original);
  (0, _lodash.default)(obj, key, value);
  return obj;
};

var mergeData = function mergeData(original, newItems) {
  return _objectSpread({}, (0, _lodash3.default)(original), {}, newItems);
};

var getTouchedObject = function getTouchedObject(fieldValidation) {
  return Object.keys(fieldValidation).reduce(function (current, name) {
    var _objectSpread2;

    return _objectSpread({}, current, (_objectSpread2 = {}, _objectSpread2[name] = true, _objectSpread2));
  }, {});
};

var Form =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Form, _Component);

  function Form(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _reactAutobind.default)(_assertThisInitialized(_this));
    var initialData = _this.props.initialData || _this.props.formData;

    var _runFormValidation = (0, _runFormValidation3.default)(initialData, _this.props.fieldValidation),
        fieldValidationResult = _runFormValidation.fieldValidationResult;

    var analyticsTracking = (0, _trackForm.default)(props.name);
    var currentValue;
    _this.state = {
      error: false,
      formData: initialData,
      validationData: fieldValidationResult,
      touched: {}
    };
    _this.initialState = (0, _lodash3.default)(_this.state);

    _this.gaChangeField = function (e) {
      // special case for checkboxes because hidden so no blur event
      if (e.target.type === 'checkbox') {
        analyticsTracking(e);
      }
    };

    _this.gaButtonClick = function (e) {
      if (e.target.type === 'button' || e.target.type === 'submit') {
        analyticsTracking(e);
      }
    };

    _this.gaHover = function (e) {
      var trackTooltip = e.target && e.target.getAttribute('data-track-tooltip');

      if (trackTooltip) {
        analyticsTracking(e);
      }
    };

    _this.gaFocusField = function (e) {
      currentValue = e.target.value;
    };

    _this.trackEvent = function (e) {
      if (currentValue !== e.target.value) {
        analyticsTracking(e);
      }
    };

    _this.componentMounted = false;
    return _this;
  }

  var _proto = Form.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.componentMounted = true;
  } // eslint-disable-next-line camelcase
  ;

  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.initialData && !(0, _fastDeepEqual.default)(nextProps.formData, this.initialState.formData)) {
      this.initialState.formData = (0, _lodash3.default)(nextProps.formData);
      this.setState({
        formData: nextProps.formData
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.componentMounted = false;
  };

  _proto.onChange = function onChange(e, cb) {
    var _this2 = this;

    if (cb === void 0) {
      cb = function cb() {};
    }

    var _ref = e.target || e,
        name = _ref.name,
        value = _ref.value,
        checked = _ref.checked,
        type = _ref.type;

    var isValid = true;
    this.setState(function (state, props) {
      var formData = state.formData,
          validationData = state.validationData;
      var fieldValidation = props.fieldValidation;

      if (fieldValidation[name]) {
        isValid = fieldValidation[name](value, formData);
      }

      return {
        error: false,
        formData: setData(formData, name, type === 'checkbox' ? checked : value),
        validationData: setData(validationData, name, isValid)
      };
    }, function () {
      if (_this2.props.onChange) {
        _this2.props.onChange({
          name: name,
          value: value,
          formData: _this2.state.formData
        });
      }

      cb(_this2.state.formData);
    });
  };

  _proto.onBlur = function onBlur(e) {
    if (e === undefined) {
      return;
    }

    var _ref2 = e.target || e,
        name = _ref2.name,
        value = _ref2.value;

    var isValid = true;
    this.setState(function (state, props) {
      var validationData = state.validationData,
          touched = state.touched,
          formData = state.formData;
      var fieldValidation = props.fieldValidation;

      if (fieldValidation[name]) {
        isValid = fieldValidation[name](value, formData);
      }

      return {
        validationData: setData(validationData, name, isValid),
        touched: setData(touched, name, true)
      };
    });
  };

  _proto.onSubmit = function onSubmit(e) {
    var _this3 = this;

    var _this$props = this.props,
        validate = _this$props.validate,
        onSubmit = _this$props.onSubmit,
        fieldValidation = _this$props.fieldValidation,
        updateOnSubmit = _this$props.updateOnSubmit;
    var _this$state = this.state,
        validationData = _this$state.validationData,
        formData = _this$state.formData;
    var validationResult = validate(formData, validationData);

    var _runFormValidation2 = (0, _runFormValidation3.default)(formData, fieldValidation),
        fieldError = _runFormValidation2.fieldError,
        fieldValidationResult = _runFormValidation2.fieldValidationResult;

    var isValid = validationResult === true && !fieldError;

    if (!isValid) {
      e.preventDefault();
      this.setState({
        error: typeof validationResult === 'string' ? validationResult : false,
        validationData: fieldValidationResult,
        touched: getTouchedObject(fieldValidation)
      });
    } else {
      this.setState({
        submitting: true
      });
      return Promise.resolve(onSubmit(e, formData)).then(function () {
        if (_this3.componentMounted) {
          if (updateOnSubmit) {
            _this3.initialState.formData = (0, _lodash3.default)(_this3.state.formData);
          }

          _this3.setState({
            submitting: false
          });
        }
      }).catch(function (err) {
        if (_this3.componentMounted) {
          _this3.setState({
            error: err.message || 'Oops, something went wrong. Please try again.',
            submitting: false
          });
        }
      });
    }
  };

  _proto.onReset = function onReset() {
    if (this.props.onReset) {
      this.props.onReset(this.initialState);
    }

    this.setState((0, _lodash3.default)(this.initialState));
  };

  _proto.getError = function getError(name) {
    var validationData = this.state.validationData;
    return (0, _lodash2.default)(validationData, name, '');
  };

  _proto.getValue = function getValue(name) {
    var formData = this.state.formData;
    return (0, _lodash2.default)(formData, name, '');
  };

  _proto.setValue = function setValue(name, value, cb) {
    var _this4 = this;

    if (cb === void 0) {
      cb = function cb() {};
    }

    this.setState(function (state) {
      var formData = state.formData;
      return {
        formData: setData(formData, name, value)
      };
    }, function () {
      cb(_this4.state.formData);
    });
  };

  _proto.setValues = function setValues(data, cb) {
    var _this5 = this;

    if (cb === void 0) {
      cb = function cb() {};
    }

    this.setState(function (state) {
      var formData = state.formData;
      return {
        formData: mergeData(formData, data)
      };
    }, function () {
      cb(_this5.state.formData);
    });
  };

  _proto.isTouched = function isTouched(name) {
    var touched = this.state.touched;
    return (0, _lodash2.default)(touched, name, false);
  };

  _proto.hasError = function hasError(name) {
    var _this$state2 = this.state,
        touched = _this$state2.touched,
        validationData = _this$state2.validationData;
    return (0, _lodash2.default)(validationData, name, false) !== true && (0, _lodash2.default)(touched, name, false);
  };

  _proto.runFieldValidation = function runFieldValidation(name, value) {
    var fieldValidation = this.props.fieldValidation;
    var _this$state3 = this.state,
        validationData = _this$state3.validationData,
        touched = _this$state3.touched,
        formData = _this$state3.formData;
    var isValid = true;

    if (fieldValidation[name]) {
      isValid = fieldValidation[name](value, formData);
    }

    this.setState({
      validationData: setData(validationData, name, isValid),
      touched: setData(touched, name, true)
    });
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        validate = _this$props2.validate,
        onSubmit = _this$props2.onSubmit,
        onReset = _this$props2.onReset,
        initialData = _this$props2.initialData,
        x = _this$props2.formData,
        y = _this$props2.fieldValidation,
        z = _this$props2.updateOnSubmit,
        props = _objectWithoutPropertiesLoose(_this$props2, ["children", "validate", "onSubmit", "onReset", "initialData", "formData", "fieldValidation", "updateOnSubmit"]);

    var _this$state4 = this.state,
        validationData = _this$state4.validationData,
        formData = _this$state4.formData,
        error = _this$state4.error,
        submitting = _this$state4.submitting;
    var isPristine = (0, _fastDeepEqual.default)(this.initialState.formData, formData);
    var isValid = validate(formData, validationData) === true;
    var formApi = {
      runFieldValidation: this.runFieldValidation,
      onChange: this.onChange,
      onBlur: this.onBlur,
      resetForm: this.onReset,
      formData: formData,
      validationData: validationData,
      isPristine: isPristine,
      isValid: isValid,
      setValue: this.setValue,
      setValues: this.setValues,
      getValue: this.getValue,
      hasError: this.hasError,
      getError: this.getError,
      isTouched: this.isTouched,
      canSubmit: !isPristine && isValid,
      isSubmitting: submitting,
      ServerValidation: function ServerValidation() {
        return _react.default.createElement(_Validation.default, {
          center: true,
          visible: Boolean(error)
        }, error || '');
      }
    };
    return (// eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
      _react.default.createElement("form", _extends({}, props, {
        onSubmit: this.onSubmit,
        onReset: this.onReset,
        onFocus: this.gaFocusField,
        onChange: this.gaChangeField,
        onBlur: this.trackEvent,
        onClick: this.gaButtonClick,
        onMouseOver: this.gaHover
      }), children(formApi))
    );
  };

  return Form;
}(_react.Component);

Form.displayName = 'Form';
Form.propTypes = {
  onChange: _propTypes.func,
  onReset: _propTypes.func,
  onSubmit: _propTypes.func.isRequired,
  children: _propTypes.func.isRequired,
  updateOnSubmit: _propTypes.bool,
  name: _propTypes.string,
  formData: _propTypes.object,
  // eslint-disable-line react/forbid-prop-types
  validate: _propTypes.func,
  fieldValidation: _propTypes.object,
  // eslint-disable-line react/forbid-prop-types
  initialData: _propTypes.object // eslint-disable-line react/forbid-prop-types

};
Form.defaultProps = {
  onChange: undefined,
  updateOnSubmit: false,
  onReset: undefined,
  validate: function validate() {
    return true;
  },
  formData: {},
  fieldValidation: {},
  name: 'Form',
  initialData: undefined
};
var _default = Form;
exports.default = _default;